import { render } from "./Danger.vue?vue&type=template&id=af6bac52"
import script from "./Danger.vue?vue&type=script&lang=js"
export * from "./Danger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__